import React from "react";
import { ProgressBar, Card } from "react-bootstrap";
import SuperTableProductivity from "../../SuperTableProdutivity";
import { useTranslation } from "react-i18next";
import _ from "lodash";


const TaskList = ({ dataFilter, user , availableHours, hasfilterDate, formaDate }) => { 

  const [t, i18n] = useTranslation("productivity");

  const columns = [
    {
      selector: "Propietario",
      caption: t("productivity_table_manager"),
      customRender: (row) => {
        return <span>{row.data.Propietario}</span>;
      },
    },
    {
      selector: "Actividad",
      caption: t("productivity_table_activity"),
      customRender: (row) => {
        return <span className="text-danger">{row.data.NombreActividad}</span>;
      },
    },
    {
      selector: "vFechaInicio",
      caption: t("productivity_table_start"),
      customRender: (row) => {
        return (
          <>
            <span>{row.data.vFechaInicio}</span>
          </>
        );
      },
      align: "center",
      width: 100,
    },
    {
      selector: "vFechaFin",
      caption: t("productivity_table_end"),
      customRender: (row) => {
        return (
          <>
            <span>{row.data.vFechaFin}</span>
          </>
        );
      },
      align: "center",
      width: 100,
    },
    {
      selector: "CantidadHorasPlaneadas",
      caption: t("productivity_table_planhours"),
      customRender: (row) => {
        return <span>{row.data.CantidadHorasPlaneadas} Hrs.</span>;
      },
      width: 100,
    },
    {
      caption: t("productivity_table_executehours"),
      customRender: (row) => {
        return <span>{row.data.CantidadHorasReales} Hrs.</span>;
      },
      width: 100,
      align: "right",
    },
    {
      selector: "%esfuerzo",
      caption: "% Esfuerzo Ejecutado",
      customRender: (row) => {
        const percent = row.data.CantidadHorasPlaneadas !== 0 ? parseFloat(((row.data.CantidadHorasReales / row.data.CantidadHorasPlaneadas ) * 100).toFixed(1)) : 0;
        return(
          <div className="flex items-center"><span>{percent}%</span></div>
        )
      },
      align: "center",
      width: 100,
    },
    {
      selector: "Avance",
      caption:"Estado",
      customRender: (row) => {
        return (
          <>
            {row.data.Avance === "Done" && (
              <>
                <span className="mr-2">
                  <i className="fa fa-circle text-success"></i>{" "}
                  {row.data.Avance}
                </span>
              </>
            )}
            {row.data.Avance === "Doing" && (
              <>
                <span className="mr-2">
                  <i className="fa fa-circle text-info"></i> {row.data.Avance}
                </span>
              </>
            )}
            {row.data.Avance === "To Do" && (
              <>
                <span className="mr-2">
                  <i className="fa fa-circle text-light"></i> {row.data.Avance}
                </span>
              </>
            )}
            {row.data.Avance !== "To Do" &&
              row.data.Avance !== "Doing" &&
              row.data.Avance !== "Done" && <span>{row.data.Avance}</span>}
          </>
        );
      },
      align: "center",
      width: 100,
    },
    {
      selector: "FechaModificado",
      caption: t("productivity_table_lastmod"),
      customRender: (row) => {
        return <span> {row.data.FechaModificado}</span>;
      },
      width: 120,
    },
  ];

  const projectsHeader = (data) => {
    const reducer = (accumulator, currentValue) => accumulator + currentValue;
    const totalHrsPlanByProject = (idUser, idProject) => {
      let projectByuser = dataFilter.filter(
        (proje) => proje.IdUsuario === idUser
      );
      return projectByuser
        .filter((fl) => fl.IdProyecto === idProject)
        .map((item) => item.CantidadHorasPlaneadas)
        .reduce(reducer);
    };
    const totalHrsEjecbyProject = (idUser, idProject) => {
      let projectByuser = dataFilter.filter(
        (proje) => proje.IdUsuario === idUser
      );
      return projectByuser
        .filter((fl) => fl.IdProyecto === idProject)
        .map((item) => item.CantidadHorasReales)
        .reduce(reducer);
    };
    const pctEjecByProject = (idUser, idProject) => {
      let plan = totalHrsPlanByProject(idUser, idProject);
      let ejec = totalHrsEjecbyProject(idUser, idProject);
      if (plan != 0) {
        return Math.round((ejec * 100) / plan);
      } else {
        return 0;
      }
    };

    return data.map((activity) => {
      return {
        ...activity,
        Proyecto: `${activity.Proyecto} ( ${t(
          "productivity_table_planhours"
        )}: ${totalHrsPlanByProject(
          activity.IdUsuario,
          activity.IdProyecto
        )} | ${t("productivity_table_executehours")}:${totalHrsEjecbyProject(
          activity.IdUsuario,
          activity.IdProyecto
        )} | % ${t("productivity_table_avanced")}: ${pctEjecByProject(
          activity.IdUsuario,
          activity.IdProyecto
        )} )`,
      };
    });
  };

  const renderDataProjects = (itemId) => {
    if (dataFilter.length > 0) {
      let personalProjects = [];
      personalProjects = projectsHeader(
        dataFilter?.filter((proje) => proje.IdUsuario === itemId)
      );
      return personalProjects;
    }
  };

 //CantidadHorasReales
  const reducer = (accumulator, currentValue) => accumulator + currentValue;
  const totalHrsPlan = (id) => {
    let filterMainData = renderDataProjects(id);
    let hrsPlan =
      filterMainData?.length > 0
        ? filterMainData
            .map((item) => item.CantidadHorasPlaneadas)
            .reduce(reducer)
        : 0;
    return Math.round(hrsPlan + Number.EPSILON);
  };
  const totalHrsEjec = (id) => {
    let filterMainData = renderDataProjects(id);
    let hrsEjec =
      filterMainData?.length > 0
        ? filterMainData.map((item) => item.CantidadHorasReales).reduce(reducer)
        : 0;
    return Math.round(hrsEjec + Number.EPSILON);
  };
  const pctEjec = (id) => {
    let plan = totalHrsPlan(id);
    let ejec = totalHrsEjec(id);
    if (plan != 0) {
      return Math.round((ejec * 100) / plan);
    } else {
      return 0;
    }
  };

  const pctDisponible = ()=> {
    const horasDispo = availableHours?.HorasCapacidad ? availableHours?.HorasCapacidad : 0
    const horasPlan = totalHrsPlan(user.IdUsuario)
    if (horasDispo === 0) {
      return 0; 
    }
    let available = (1- (horasPlan / horasDispo)) *100 ; 
    return `${Number.isInteger(available) ? available : available.toFixed(2)}`
 
  }

  const pctAsignado = ()=>{
    const horasPlan = totalHrsPlan(user.IdUsuario)
    const horasDispo = availableHours?.HorasCapacidad ? availableHours?.HorasCapacidad : 0
    if (horasDispo === 0) {
      return 0; 
    }

    let Assignments = ( horasPlan / horasDispo ) * 100 ; 
    return `${Number.isInteger(Assignments) ? Assignments : Assignments.toFixed(2)}`

  }

  const dataFilterByUser = dataFilter.filter((dt)=>{
    return dt.IdUsuario === user.IdUsuario
  })

  const planHoursInter = dataFilterByUser.length > 0 ? _.sumBy(dataFilterByUser,'HorasPlaneadasFiltro').toFixed(2) : 0
  const realHoursInter = dataFilterByUser.length > 0 ? _.sumBy(dataFilterByUser,'HorasRealesFiltro').toFixed(2) : 0

    const pctEjecFilt = (plan, real) => {

    if (plan != 0) {
      return Math.round((real * 100) / plan);
    } else {
      return 0;
    }
  };

    const pctDisponibleFil = (planfilter)=> {
    const horasDispo = availableHours?.HorasCapacidad ? availableHours?.HorasCapacidad : 0

    if (horasDispo === 0) {
      return 0; 
    }
    let available = (1- (planfilter / horasDispo)) *100 ; 
    return `${Number.isInteger(available) ? available : available.toFixed(2)}`
 
  }

  const pctAsignadoFil = (planfilter)=>{
    const horasDispo = availableHours?.HorasCapacidad ? availableHours?.HorasCapacidad : 0
    if (horasDispo === 0) {
      return 0; 
    }

    let Assignments = ( planfilter / horasDispo ) * 100 ; 
    return `${Number.isInteger(Assignments) ? Assignments : Assignments.toFixed(2)}`

  }

  return (
    <>
      <Card className="shadow-sm mb-4">
          <Card.Header className="bg-light">
            <h5 className="mb-0">
              <i className="fa fa-user text-primary mr-2"></i>
              Ocupación y Disponibilidad - Global.
            </h5>
          </Card.Header>
          <Card.Body>
          <div className="d-flex mb-2 mt-4">
            <Card className="mr-3">
              <Card.Body className="px-2 py-1 d-flex">
                <div className="d-flex flex-column  border-right pr-2 mr-2">
                  <span className="small mr-2">
                    {t("productivity_resources_plannedhours")}
                  </span>
                  <span className="text-info font-weight-bold">
                    {totalHrsPlan(user.IdUsuario)}
                  </span>
                </div>
                <div className="d-flex flex-column ">
                  <span className="small mr-2">
                    {t("productivity_resources_hours_hoursworked")}
                  </span>
                  <span className="text-success font-weight-bold">
                    {totalHrsEjec(user.IdUsuario)}
                  </span>
                </div>
              </Card.Body>
            </Card>
            <Card>
              <Card.Body className="px-2 py-1 d-flex">
                <div className="d-flex flex-column" style={{ width: "140px" }}>
                  <span className="small mr-2 mb-2">
                    <i className="fa fa-briefcase mr-2"></i>
                    {t("productivity_resources_performance")} (
                    {pctEjec(user.IdUsuario)}
                    %)
                  </span>
                  <ProgressBar
                    variant="success"
                    now={pctEjec(user.IdUsuario)}
                    style={{ height: "8px" }}
                  />
                </div>
              </Card.Body>
            </Card>
            {(hasfilterDate.start && hasfilterDate.end) && <> 
            <Card className="mx-2">
              <Card.Body className="px-2 py-1 d-flex">
                <div className="d-flex flex-column" style={{ width: "150px" }}>
                  <span className="small mr-2 mb-2">
                    <i className="fa fa-briefcase mr-2"></i>
                    Disponible (
                    {pctDisponible()}
                    %)
                  </span>
                  <ProgressBar
                    variant="info"
                    now={pctDisponible()}
                    style={{ height: "8px" }}
                  />
                </div>
              </Card.Body>
            </Card>
            <Card className="mr-3">
              <Card.Body className="px-2 py-1 d-flex">
                <div className="d-flex flex-column" style={{ width: "150px" }}>
                  <span className="small mr-2 mb-2">
                    <i className="fa fa-briefcase mr-2"></i>
                    Asignanción (
                {pctAsignado()}
                    %)
                  </span>
                  <ProgressBar
                    variant="success"
                    now={pctAsignado()}
                    style={{ height: "8px" }}
                  />
                </div>
              </Card.Body>
            </Card>

            <Card className="mr-3">
              <Card.Body className="px-2 py-1 d-flex">
                <div className="d-flex flex-column  border-right pr-2 mr-2">
                  <span className="small mr-2">
                    Capacidad
                  </span>
                  <span className="text-info font-weight-bold">
                    {availableHours?.HorasCapacidad || 0} hrs.
                  </span>
                </div>
                <div className="d-flex flex-column ">
                  <span className="small mr-2">
                    Disponibles
                  </span>
                  <span className="text-success font-weight-bold">
                    { (availableHours?.HorasCapacidad) ? 
                    <> {(availableHours?.HorasCapacidad - totalHrsPlan(user.IdUsuario)).toFixed(2) || 0} hrs </> 
                    : 
                    <> 0 </>
                    }
                    
                  </span>
                </div>
              </Card.Body>
            </Card>
            </>
            }
            <hr/>
            
          </div>
        </Card.Body> 
      </Card>
      {(hasfilterDate.start && hasfilterDate.end) && <>
      <Card className="shadow-sm mb-4">
        <Card.Header className="bg-light">
          <h5 className="mb-0">
            <i className="fa fa-user text-primary mr-2"></i>
            Ocupación y Disponibilidad - Periodo.<small> ( {formaDate(hasfilterDate.start)} - {formaDate(hasfilterDate.end)}) </small>
          </h5>
        </Card.Header>
        <Card.Body>
      <div className="d-flex mb-2 mt-4">
        <Card className="mr-3">
          <Card.Body className="px-2 py-1 d-flex">
            <div className="d-flex flex-column  border-right pr-2 mr-2">
              <span className="small mr-2">
                {t("productivity_resources_plannedhours")} filtradas
              </span>
              <span className="text-info font-weight-bold">
                {planHoursInter}
              </span>
            </div>
            <div className="d-flex flex-column ">
              <span className="small mr-2">
                {t("productivity_resources_hours_hoursworked")} filtradas
              </span>
              <span className="text-success font-weight-bold">
                {realHoursInter}
              </span>
            </div>
          </Card.Body>
        </Card>

        <Card>
          <Card.Body className="px-2 py-1 d-flex">
            <div className="d-flex flex-column" style={{ width: "140px" }}>
              <span className="small mr-2 mb-2">
                <i className="fa fa-briefcase mr-2"></i>
                {t("productivity_resources_performance")} (
                {pctEjecFilt(planHoursInter,realHoursInter)}
                %)
              </span>
              <ProgressBar
                variant="success"
                now={pctEjecFilt(planHoursInter,realHoursInter)}
                style={{ height: "8px" }}
              />
            </div>
          </Card.Body>
        </Card>

         <Card className="mx-2">
          <Card.Body className="px-2 py-1 d-flex">
            <div className="d-flex flex-column" style={{ width: "150px" }}>
              <span className="small mr-2 mb-2">
                <i className="fa fa-briefcase mr-2"></i>
                Disponible (
                {pctDisponibleFil(planHoursInter)}
                %)
              </span>
              <ProgressBar
                variant="info"
                now= {pctDisponibleFil(planHoursInter)}
                style={{ height: "8px" }}
              />
            </div>
          </Card.Body>
        </Card>
        <Card className="mr-3">
          <Card.Body className="px-2 py-1 d-flex">
            <div className="d-flex flex-column" style={{ width: "150px" }}>
              <span className="small mr-2 mb-2">
                <i className="fa fa-briefcase mr-2"></i>
                Asignanción (
            {pctAsignadoFil(planHoursInter)}
                %)
              </span>
              <ProgressBar
                variant="success"
                now={pctAsignadoFil(planHoursInter)}
                style={{ height: "8px" }}
              />
            </div>
          </Card.Body>
        </Card>

        <Card className="mr-3">
          <Card.Body className="px-2 py-1 d-flex">
            <div className="d-flex flex-column  border-right pr-2 mr-2">
              <span className="small mr-2">
                Capacidad
              </span>
              <span className="text-info font-weight-bold">
                {availableHours?.HorasCapacidad || 0} hrs.
              </span>
            </div>
            <div className="d-flex flex-column ">
              <span className="small mr-2">
                Disponibles
              </span>
              <span className="text-success font-weight-bold">
                { (availableHours?.HorasCapacidad) ? 
                <> {(availableHours?.HorasCapacidad - planHoursInter).toFixed(2) || 0} hrs. </> 
                : 
                <> 0 </>
                }
                
              </span>
            </div>
          </Card.Body>
        </Card>
      </div>
      </Card.Body>
      </Card>
      </>
      }
      <SuperTableProductivity
        title_proje="Proyecto"
        showProjectsProductivity
        columns={columns}
        data={renderDataProjects(user?.IdUsuario)}
        noSearch={false}
        textSearch={t("productivity_table_search")}
      />
    </>
  );
};

export default TaskList;
